import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Vielen Dank für Ihre Einschätzung!',
  text: 'Gibt es etwas, das wir verbessern können? Teilen Sie uns Ihre Meinung mit.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Ihre Meinung...'
      }
    ],
    submit: {
      label: 'Senden Sie'
    }
  }
};
